<template>
	<div class="top" id="aquarium">
		<div class="face1">
			<img src="../assets/squareAnimation/vue.png" alt="" />
		</div>
		<div class="face2">
			<img src="../assets/squareAnimation/js.png" alt="" />
		</div>
		<div class="face3">
			<img src="../assets/squareAnimation/sass.png" alt="" />
		</div>
		<div class="face4">
			<img src="../assets/squareAnimation/php.png" alt="" />
		</div>
		<div class="face5">
			<img src="../assets/squareAnimation/github.png" alt="" />
		</div>
		<div class="face6">
			<img src="../assets/squareAnimation/laravel.png" alt="" />
		</div>
	</div>

	<div class="bottom" id="aquarium">
		<div class="face1">
			<img src="../assets/squareAnimation/vue.png" alt="" />
		</div>
		<div class="face2">
			<img src="../assets/squareAnimation/js.png" alt="" />
		</div>
		<div class="face3">
			<img src="../assets/squareAnimation/sass.png" alt="" />
		</div>
		<div class="face4">
			<img src="../assets/squareAnimation/php.png" alt="" />
		</div>
		<div class="face5">
			<img src="../assets/squareAnimation/github.png" alt="" />
		</div>
		<div class="face6">
			<img src="../assets/squareAnimation/laravel.png" alt="" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
#aquarium {
	z-index: 1;
	width: 50px;
	height: 50px;
	display: none;
	position: fixed;
	-webkit-transform-style: preserve-3d;
	-moz-transform-style: preserve-3d;
	-ms-transform-style: preserve-3d;
	transform-style: preserve-3d;
	-webkit-animation-name: aquaCube3dRotation;
	-webkit-animation-duration: 20s;
	-webkit-animation-delay:0.1s;
	-webkit-animation-direction: reverse;
	-webkit-animation-fill-mode: forwards;
	-webkit-animation-timing-function: cubic-bezier(0.63, -0.36, 0.82, 1.57);
	-webkit-animation-iteration-count: infinite;
	animation-name: aquaCube3dRotation;
	animation-duration: 20s;
	animation-delay: 0.1s;
	animation-direction: reverse;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(0.63, -0.36, 0.82, 1.57);
	animation-iteration-count: infinite;

	-ms-animation-name: aquaCube3dRotation;
	-ms-animation-duration: 20s;
	-ms-animation-delay: 0.1s;
	-ms-animation-direction: reverse;
	-ms-animation-fill-mode: forwards;
	-ms-animation-timing-function: cubic-bezier(0.63, -0.36, 0.82, 1.57);
	-ms-animation-iteration-count: infinite;

	-moz-animation-name: aquaCube3dRotation;
	-moz-animation-duration: 20s;
	-moz-animation-delay: 0.1s;
	-moz-animation-direction: reverse;
	-moz-animation-fill-mode: forwards;
	-moz-animation-timing-function: cubic-bezier(0.63, -0.36, 0.82, 1.57);
	-moz-animation-iteration-count: infinite;

/* Chrome 29+ */
display:none;
@media screen and (-webkit-min-device-pixel-ratio:0)
  and (min-resolution:.001dpcm) {
   display: block;
}





	
	&.bottom {
		bottom: 100px;
		right: 200px;
		@media (max-width: 692px) {
			display: none;
		}
	}
	&.top {
		top: 50px;
		left: 150px;
	}
}
@keyframes aquaCube3dRotation {
	0% {
		transform: rotate3d(1, 1, 1, 0);
		-moz-transform: rotate3d(1, 1, 1, 0);
		-ms-transform: rotate3d(1, 1, 1, 0);
		-o-transform: rotate3d(1, 1, 1, 0);
		-webkit-transform: rotate3d(1, 1, 1, 0);
	}

	100% {
		transform: rotate3d(1, 1, 1, 720deg);
		-moz-transform: rotate3d(1, 1, 1, 720deg);
		-ms-transform: rotate3d(1, 1, 1, 720deg);
		-o-transform: rotate3d(1, 1, 1, 720deg);
		-webkit-transform: rotate3d(1, 1, 1, 720deg);
	}
}

div:hover {
	-webkit-animation-play-state: paused;
	animation-play-state: paused;
}

img {
	width: 30px;
	height: 30px;
}

.face1,
.face2,
.face3,
.face4,
.face5,
.face6 {
	background: #0c1c38;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid #1f585e;
}

#aquarium div {
	position: absolute;
	height: 50px;
	width: 50px;
}

.face1 {
	top: 0;
	left: 0;
	-webkit-transform: translate3d(0, 0, 50px);
	transform: translate3d(0, 0, 50px);
	-moz-transform: translate3d(0, 0, 50px);
	-ms-transform: translate3d(0, 0, 50px);
}

.face2 {
	top: 0;
	left: 0;
	-webkit-transform: translate3d(0, 0, 0px);
	transform: translate3d(0, 0, 0px);
	-moz-transform: translate3d(0, 0, 0px);
	-ms-transform: translate3d(0, 0, 0px);
}

.face3 {
	top: 0;
	left: 100%;
	-webkit-transform-origin: 0 0;
	-webkit-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, 90deg);
	transform-origin: 0 0;
	transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, 90deg);
	-moz-transform-origin:  0 0;
	-moz-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, 90deg);
	-ms-transform-origin: 0 0;
	-ms-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, 90deg);
}

.face4 {
	top: 100%;
	left: 0;

	-webkit-transform-origin: 0 0;
	-webkit-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, -90deg);

	-moz-transform-origin: 0 0;
	-moz-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, -90deg);

	-ms-transform-origin: 0 0;
	-ms-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, -90deg);

	transform-origin: 0 0;
	transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, -90deg);
}

.face5 {
	top: 0;
	right: 100%;
	-webkit-transform-origin: 100% 0;
	-webkit-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, -90deg);
	transform-origin: 100% 0;
	transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, -90deg);

	-ms-transform-origin: 100% 0;
	-ms-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, -90deg);
	-moz-transform-origin: 100% 0;
	-moz-transform: translate3d(0, 0, 50px) rotate3d(0, 1, 0, -90deg);
}

.face6 {
	bottom: 100%;
	left: 0;
	-webkit-transform-origin: 0 100%;
	-webkit-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, 90deg);
	transform-origin: 0 100%;
	transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, 90deg);

	-ms-transform-origin: 0 100%;
	-ms-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, 90deg);
	-moz-transform-origin: 0 100%;
	-moz-transform: translate3d(0, 0, 50px) rotate3d(1, 0, 0, 90deg);
}




</style>
